import { render } from "./SectionContact.vue?vue&type=template&id=4824dd6a&scoped=true"
import script from "./SectionContact.vue?vue&type=script&lang=js"
export * from "./SectionContact.vue?vue&type=script&lang=js"

import "./SectionContact.vue?vue&type=style&index=0&id=4824dd6a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4824dd6a"

export default script